"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageAudioHandler = void 0;
const taskSetup_1 = require("../../taskSetup");
const __1 = require("../../..");
class PageAudioHandler {
    constructor() {
        throw new Error('Cannot initialize the singleton static class PageAudioHandler');
    }
    static stopAndDisconnectNode() {
        if (PageAudioHandler.audioSource) {
            PageAudioHandler.audioSource.stop();
            PageAudioHandler.audioSource.disconnect();
            PageAudioHandler.audioSource = undefined;
        }
    }
    static async getAudioDuration(audioUri) {
        const audioBuffer = (await taskSetup_1.jsPsych.pluginAPI.getAudioBuffer(audioUri));
        return audioBuffer === null || audioBuffer === void 0 ? void 0 : audioBuffer.duration;
    }
    static async playAudio(audioUri, config = this.defaultAudioConfig, setClassAudioField = true) {
        const { enabled, maxRepetitions } = config.restrictRepetition;
        const { onEnded } = config;
        // check for repeat audio
        if (PageAudioHandler.audioUri === audioUri && enabled) {
            PageAudioHandler.replays++;
        }
        else if (enabled) {
            PageAudioHandler.replays = 0;
        }
        if (setClassAudioField) {
            PageAudioHandler.audioUri = audioUri;
        }
        // replace audio with ding if it has already been played twice
        if (PageAudioHandler.replays > maxRepetitions && enabled) {
            audioUri = __1.mediaAssets.audio.inputAudioCue;
        }
        try {
            const jsPsychAudioCtx = taskSetup_1.jsPsych.pluginAPI.audioContext();
            // Returns a promise of the AudioBuffer of the preloaded file path.
            const audioBuffer = (await taskSetup_1.jsPsych.pluginAPI.getAudioBuffer(audioUri));
            const audioSource = jsPsychAudioCtx.createBufferSource();
            PageAudioHandler.audioSource = audioSource;
            audioSource.buffer = audioBuffer;
            audioSource.connect(jsPsychAudioCtx.destination);
            audioSource.onended = () => {
                if (PageAudioHandler.replays === maxRepetitions && enabled) {
                    const audioConfig = {
                        restrictRepetition: {
                            enabled: false,
                            maxRepetitions: 2,
                        },
                        onEnded: () => {
                            if (onEnded)
                                onEnded();
                        },
                    };
                    PageAudioHandler.playAudio(__1.mediaAssets.audio.inputAudioCue, audioConfig, false);
                }
                else {
                    if (onEnded)
                        onEnded();
                }
            };
            audioSource.start(0);
        }
        catch {
            // Swallow errors to avoid test/runtime crashes when audio cannot be played
            return;
        }
    }
    // required on iOS to prevent autoplay blocking
    static unlockAudioContext() {
        const ctx = taskSetup_1.jsPsych.pluginAPI.audioContext();
        // safari requires resuming audio context on user interaction, then it can be used freely later
        if (ctx.state === 'suspended') {
            ctx.resume();
        }
        const buffer = ctx.createBuffer(1, 1, ctx.sampleRate);
        const source = ctx.createBufferSource();
        source.buffer = buffer;
        source.connect(ctx.destination);
        source.start(0);
    }
}
exports.PageAudioHandler = PageAudioHandler;
PageAudioHandler.replays = 0;
PageAudioHandler.defaultAudioConfig = {
    restrictRepetition: {
        enabled: true,
        maxRepetitions: 2,
    },
};
